"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _moment = _interopRequireDefault(require("moment"));

var _markdownToJsx = _interopRequireDefault(require("markdown-to-jsx"));

var _semanticUiReact = require("semantic-ui-react");

var _proptypes = require("../../services/proptypes");

var _Image = _interopRequireDefault(require("../../atoms/Image"));

var _Link = _interopRequireDefault(require("../../atoms/Link"));

var _SEO = require("../../darkmatter/SEO");

var _BlogPost = require("./BlogPost.presenters");

require("./BlogPost.css");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var BlogPost = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2["default"])(BlogPost, _React$PureComponent);

  var _super = _createSuper(BlogPost);

  function BlogPost() {
    (0, _classCallCheck2["default"])(this, BlogPost);
    return _super.apply(this, arguments);
  }

  (0, _createClass2["default"])(BlogPost, [{
    key: "getHeaderText",
    value: function getHeaderText() {
      var _this$props = this.props,
          publishedAt = _this$props.publishedAt,
          author = _this$props.author;
      var authorString = (0, _BlogPost.formatAuthor)(author);
      var headerParts = publishedAt ? [(0, _moment["default"])(publishedAt).format('LL')] : [];

      if (author) {
        headerParts = [authorString].concat((0, _toConsumableArray2["default"])(headerParts));
      }

      return headerParts.join(' | ');
    }
  }, {
    key: "getContent",
    value: function getContent() {
      var _this$props2 = this.props,
          content = _this$props2.content,
          markdown = _this$props2.markdown;
      return markdown ? /*#__PURE__*/_react["default"].createElement(_markdownToJsx["default"], null, content) : content;
    }
  }, {
    key: "createSchemaProps",
    value: function createSchemaProps() {
      var _this$props3 = this.props,
          author = _this$props3.author,
          publishedAt = _this$props3.publishedAt,
          heroImage = _this$props3.heroImage;
      return _objectSpread(_objectSpread({}, this.props), {}, {
        datePublished: publishedAt,
        author: (0, _BlogPost.formatAuthor)(author),
        // TODO remove when upgrading node version, replace with optional chaining
        heroImage: heroImage && heroImage.fluid && heroImage.fluid.src
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          title = _this$props4.title,
          heroImage = _this$props4.heroImage,
          markdown = _this$props4.markdown;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_SEO.BlogPostSchema, this.createSchemaProps()), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Breadcrumb, {
        className: "blog-post-breadcrumbs"
      }, /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Breadcrumb.Section, {
        as: _Link["default"],
        title: "Blog",
        to: "/blog"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Breadcrumb.Divider, {
        icon: "right chevron"
      }), /*#__PURE__*/_react["default"].createElement(_semanticUiReact.Breadcrumb.Section, null, title)), /*#__PURE__*/_react["default"].createElement("article", null, /*#__PURE__*/_react["default"].createElement("header", null, /*#__PURE__*/_react["default"].createElement("h1", null, title), heroImage && /*#__PURE__*/_react["default"].createElement(_Image["default"], {
        src: heroImage,
        className: "blog-post-image"
      }), /*#__PURE__*/_react["default"].createElement("h4", null, this.getHeaderText())), /*#__PURE__*/_react["default"].createElement("section", {
        className: "blog-post-content-section ".concat(markdown ? '' : 'white-space-line-break')
      }, this.getContent())));
    }
  }]);
  return BlogPost;
}(_react["default"].PureComponent);

exports["default"] = BlogPost;
BlogPost.propTypes = {
  title: _propTypes["default"].string.isRequired,
  publishedAt: _propTypes["default"].string.isRequired,
  author: _propTypes["default"].shape({
    firstName: _propTypes["default"].string,
    lastName: _propTypes["default"].string,
    avatar: _propTypes["default"].string,
    email: _propTypes["default"].string
  }),
  heroImage: _propTypes["default"].oneOfType([_propTypes["default"].string, _proptypes.GatsbyImagePropType]),
  content: _propTypes["default"].string.isRequired,
  markdown: _propTypes["default"].bool,
  summary: _propTypes["default"].string
};
BlogPost.defaultProps = {
  heroImage: null,
  author: null,
  markdown: false,
  summary: ''
};